// extracted by mini-css-extract-plugin
module.exports =  {"title":"M1ZGRWF"};